import { render, staticRenderFns } from "./backwater.vue?vue&type=template&id=524377ae&"
import script from "./backwater.vue?vue&type=script&lang=js&"
export * from "./backwater.vue?vue&type=script&lang=js&"
import style0 from "./backwater.vue?vue&type=style&index=0&id=524377ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports